import { z } from 'zod';

export const settlementSchema = z.object({
  id: z.number().int().positive().optional(),
  amount: z.number().int().nonnegative(),
  claim_section_id: z.number().int().positive(),
  office_id: z.number().int().positive(),
  display_name: z.string().min(1, 'Display name is required').max(255),
  icon: z.string().min(1, 'Icon is required').max(100).optional(),
  initial_offer: z.number().int().nonnegative().nullable().optional(),
  attorney_settlement: z
    .array(z.object({ attorney_id: z.number().int().positive() }))
    .optional(),
});

export type SettlementInput = z.infer<typeof settlementSchema>;
